module.exports = __webpack_public_path__ + "static/img/SC.d960317c.png";